export default {
  creationTime: "Erstellzeit",
  creationDate: "Erstelldatum",
  measurementDate: "Messzeitpunkt",
};
